<template>
	<div class="row" id="bottom-menu">
		<div class="col-lg-6 ">
			<i @click="isOpen ? isOpen=false : isOpen = true " class="fa fa-files-o" aria-hidden="true"></i>
		</div>
		<div class="col-lg-6 text-right">
			<a   id="botton-send-server" class="send-btn" @click="sendToServer">
				<i aria-hidden="true" class="fa fa-floppy-o"></i>
				Готово
			</a>		
		</div>
		<div class="col-lg-12" v-show="isOpen">
			<bottom-files></bottom-files>
		</div>
	</div>
</template>

<script>
	import axios from 'axios'

	import BottomFiles from './BottomFiles'

	export default {

		name: 'bottom-menu',

		props: {
			www: {
				type: Object,
				required: true,
			}
		},
		watch: {
			www(data) {
			}
		},
		data() {
			return {
				isOpen: false
			}
			
		},
		components: {
			BottomFiles,
		},
		created() {
			console.log(this.www)
			eventBus.$on('sendLinkAndMethod', (data) => {
				this.content = data

			})
		},
		 beforeDestroy() {
            eventBus.$off('sendLinkAndMethod')
        },
		methods: {
			openModal() {
				this.isOpen ? this.isOpen=false : this.isOpen = true 
			},
			sendToServer() {
				if(this.www.method == 'post') {

					axios.post(this.www.link_send, {
						www: this.www
					})
					.then(response => {
						console.log(response);

					 iziToast.show({
        color: 'dark',
        icon: 'fa fa-envelope-open-o',
        title: 'System',
        message: 'Success! Thanks, Well done!',
        position: 'topRight', 
        progressBarColor: '#777',
      
      });
						
						if(this.www.redirect) {
							this.$router.go(-1)
							// this.$router.push({ name: this.www.redirect })
							
						}
						return
						console.log(this.www)

					})
					.catch(error => {
						console.log(this.www)

						var serverErrors = Object.values(error.response.data.errors)

						eventBus.$emit('errors', serverErrors)

						// iziToast.show({
						// 	theme: 'dark',
						// 	title: 'Грешка',
						// 	message: 'Инвалидни дани',
						// 	position: 'topRight', 
						// 	progressBarColor: 'rgb(255, 255, 255)',
						// 	icon: 'fa fa-exclamation-triangle',
						// });
iziToast.error({title: 'Error', message: 'Инвалидни дани', position: 'topRight',});
     
					})
				}
				console.log(this.www.method)
				if(this.www.method == 'patch') {
					
					axios.patch(this.www.link_send, {
						www: this.www
					})
					.then(response => {

						// iziToast.show({
						// 	theme: 'dark',
						// 	title: 'готово',
						// 	message: response.data,
						// 	position: 'topRight', 
						// 	progressBarColor: 'rgb(255, 255, 255)',
						// 	icon: 'fa fa-exclamation-triangle',
						// });
						if(this.www.redirect) {
							// this.$router.push({ name: this.www.redirect })
							this.$router.go(-1)
							
							
						}
						return

					})
					.catch(error => {
						console.log(error)

						var serverErrors = Object.values(error.response.data.errors)

						eventBus.$emit('errors', serverErrors)

						// iziToast.show({
						// 	theme: 'dark',
						// 	title: 'Грешка',
						// 	message: 'Инвалидни дани',
						// 	position: 'topRight', 
						// 	progressBarColor: 'rgb(255, 255, 255)',
						// 	icon: 'fa fa-exclamation-triangle',
						// });
					})
				}

			}
		},
		
		updateCategory() {
		}

	}	
</script>

<style scoped>
#botton-send-server {
	text-align: right;
}
#bottom-menu {
	position: fixed;
	bottom: 0;
	width: 100%;
	background: #fff;
	padding: 10px;
	box-shadow: 0px 6px 30px rgba(0,0,0,.1);
	border-radius: 3px;
	z-index: 10;
}
.fa-files-o {
	cursor: pointer;
}
.send-btn {
    margin-left: 15px;
    color: #17a2b8!important;
    padding: 5px 20px;
    text-decoration: none;
    cursor: pointer;
    border: 1px solid #17a2b8;
    border-radius: 8px;
    height: 2.3em;
    width: 200px;
    outline: none;
    overflow: hidden;
    color: #17a2b8;
    text-align: center;
    line-height: 222%;
}
.send-btn:hover {
	color:#fff!important;
	background: #17a2b8;
}
</style>



// WEBPACK FOOTER //
// src/components/app_modules/BottomMenu.vue